var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"documentation-page"},[_c('DocHeader'),_c('DocSidebar'),_c('div',{staticClass:"content"},[_c('breadcrumb-history'),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }